import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { FuncionarioService } from './../../services/funcionario.service';

@Component({
  selector: 'app-monitoramento-funcionario-modal',
  templateUrl: './monitoramento-funcionario-modal.component.html',
  styleUrls: ['./monitoramento-funcionario-modal.component.scss']
})
export class MonitoramentoFuncionarioModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};

  valorTotal = 0;
  idFuncionario = 0;
  monitoramentos = [
    { id: 0, nome: 'Vendas', checado: false },
    { id: 1, nome: 'Integração', checado: false },
    { id: 2, nome: 'Financiamento', checado: false },
    { id: 3, nome: 'Financeiro', checado: false },
    { id: 4, nome: 'Separação', checado: false },
    { id: 5, nome: 'Fiscal', checado: false },
    { id: 6, nome: 'Expedição', checado: false },
    { id: 7, nome: 'Menu Geral', checado: false },
    { id: 9, nome: 'Controle de Ocorrências', checado: false },
    { id: 10, nome: 'Monitor Pedidos', checado: false },
    { id: 11, nome: 'Contato/Integrador', checado: false }];
  monitoramentosFuncionario = [];
  selecaoTodos = false;


  constructor(public dialogRef: MatDialogRef<MonitoramentoFuncionarioModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private funcionarioService: FuncionarioService,
    private carregandoService: CarregandoService, private notificacaoService: NotificacaoService) { }

  ngOnInit() {
    this.idFuncionario = this.data.idFuncionario;
    this.buscarMonitoramentosDoFuncionario();
  }

  buscarMonitoramentosDoFuncionario() {
    this.carregandoService.mostra('buscarMonitoramentosDoFuncionario');

    this.funcionarioService.buscarMonitoramentos(this.idFuncionario).subscribe(
      (res) => {
        this.monitoramentosFuncionario = res;

        this.monitoramentos.forEach(p => {
          p.checado = this.monitoramentosFuncionario.some(m => m === p.id);
        });

        this.carregandoService.esconde('buscarMonitoramentosDoFuncionario');
      },
      (erro) => {
        this.carregandoService.esconde('buscarMonitoramentosDoFuncionario');
        this.notificacaoService.erro(erro);
      }
    );
  }

  salvar() {
    this.carregandoService.mostra('salvarMonitoramentosDoFuncionario');

    this.funcionarioService.salvarMonitoramentos({ idFuncionario: this.idFuncionario, monitoramentos: this.monitoramentos.filter(p => p.checado).map(p => p.id) }).subscribe(
      (res) => {
        this.monitoramentos = res;

        this.carregandoService.esconde('salvarMonitoramentosDoFuncionario');
        this.notificacaoService.sucesso('Monitoramentos salvos com sucesso!!!');
        this.fechar();
      },
      (erro) => {
        this.carregandoService.esconde('salvarMonitoramentosDoFuncionario');
        this.notificacaoService.erro(erro);
      }
    );


  }

  selecionarTodos() {
    this.monitoramentos.forEach(p => p.checado = this.selecaoTodos);
  }



  fechar() {
    this.dialogRef.close();
  }

}
